var _path, _g, _path2, _g2, _path3, _path4, _path5, _path6, _path7, _g3, _path8, _path9, _g4, _path0, _g5, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoToTestImagePersonRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 127,
    viewBox: "0 0 195 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.6322 103.221L20.6884 63.4268L10.5663 68.6792C10.5663 68.6792 19.1053 116.455 33.5834 117.199C48.0616 117.948 43.6269 103.221 43.6269 103.221H43.6322Z",
    fill: "#FF6F59"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.6322 103.221L20.6884 63.4268L10.5663 68.6792C10.5663 68.6792 19.1053 116.455 33.5834 117.199C48.0616 117.948 43.6269 103.221 43.6269 103.221H43.6322Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2009 43.8871C94.2009 43.8871 34.6582 21.6642 38.9775 98.4546L94.2009 43.8871Z",
    fill: "#FF6F59"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.9775 98.4615L94.2009 43.894C94.2009 43.894 34.6582 21.671 38.9775 98.4615Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.765 12.6247C110.765 12.6247 105.743 19.3133 103.877 24.8576C103.123 27.1062 104.197 29.6409 106.268 30.4305C108.841 31.4146 112.579 31.9353 115.672 28.7083L121.532 23.9364C121.532 23.9364 125.107 20.8066 123.236 15.1593C121.364 9.51779 113.638 8.3849 110.77 12.6247H110.765Z",
    fill: "#F4A28C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.592 21.7617L114.969 49.6377L101.078 45.7584L110.021 27.0314L119.592 21.7617Z",
    fill: "#F4A28C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.201 14.135C113.302 15.0505 115.404 16.6068 118.544 18.1287C118.544 18.1287 114.555 19.7079 114.455 24.6571C114.356 29.6064 118.607 30.5905 118.607 30.5905L124.242 21.3443C125.961 18.7066 126.239 15.2507 124.929 12.3441C124.394 11.1597 123.765 9.90097 123.063 8.75664C121.307 5.8958 116.662 5.00894 115.614 1.61027C115.153 0.122642 113.386 -0.283592 112.406 0.872184C110.283 3.37827 107.987 8.10436 110.487 12.2125C110.943 12.9621 111.546 13.5857 112.201 14.135Z",
    fill: "#992D1C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.884 23.9193C113.884 23.9193 115.656 21.2072 117.412 22.8322C119.168 24.4571 116.636 28.3879 113.832 26.8431L113.884 23.9193Z",
    fill: "#F4A28C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M107.798 17.0186L104.255 18.4089C103.379 18.7522 103.128 19.9709 103.788 20.6919L105.969 23.0721L107.804 17.0243L107.798 17.0186Z",
    fill: "#F4A28C"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.903 31.0421C107.903 31.0421 110.576 31.4426 113.192 29.8691C113.192 29.8691 111.431 34.6868 104.962 37.6334L107.903 31.0478V31.0421Z",
    fill: "#CE8172"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M151.385 86.9428C150.315 68.4104 124.205 51.7946 107.725 47.1887L101.56 45.4665C101.56 45.4665 58.7551 31.6372 44.1407 73.1879C29.521 114.739 38.1649 154.115 38.1649 154.115L108.779 162.995C108.779 162.995 153.785 128.482 151.379 86.9485L151.385 86.9428Z",
    fill: "#FF6F59"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M120.908 52.7509C120.908 52.7509 123.367 45.1868 115.011 41.5307C106.655 37.8745 98.2736 34.3328 94.2007 43.8937C94.2007 43.8937 101.062 51.5436 120.908 52.7566V52.7509Z",
    fill: "#FF6F59"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.908 52.7509C120.908 52.7509 123.367 45.1868 115.011 41.5307C106.655 37.8745 98.2736 34.3328 94.2007 43.8937C94.2007 43.8937 101.062 51.5436 120.908 52.7566V52.7509Z",
    fill: "white"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M185.584 120.249C185.584 120.249 191.332 130.183 179.984 125.444C144.035 141.396 116.426 112.902 118.444 80.9694C119.419 65.561 137.137 59.7821 145.702 72.078C149.309 77.2561 152.433 83.9333 154.005 92.4528C159.221 120.758 159.717 127.046 169.298 127.046C175.45 123.909 179.984 120.249 179.984 120.249L185.584 120.249Z",
    fill: "#FF6F59"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.399 120.249C178.399 120.249 217.451 122.12 172.172 142.209C142.952 140.117 116.426 112.902 118.444 80.9694C119.419 65.561 137.137 59.7821 145.702 72.078C149.309 77.2561 152.433 83.9333 154.005 92.4528C159.221 120.758 169.588 141.928 167.382 120.249C170.735 120.249 172.172 120.249 172.172 120.249L178.399 120.249Z",
    fill: "white"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6884 63.4271C20.6884 63.4271 14.4924 56.6698 11.6251 48.0702C8.75781 39.4705 4.90501 46.6855 7.4054 51.3601C9.90578 56.0347 -1.33285 52.3214 0.538511 60.6864C2.40987 69.0515 10.5663 68.6796 10.5663 68.6796L20.6884 63.4271Z",
    fill: "#F4A28C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoToTestImagePersonRed);
export default __webpack_public_path__ + "static/media/go-to-test-image-person-red.a707baa195a60eca36caddd63bcbe525.svg";
export { ForwardRef as ReactComponent };